var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9974 1.33203C6.1594 1.33203 4.66406 2.82736 4.66406 4.66536V6.66536H3.9974C3.64377 6.66536 3.30464 6.80584 3.05459 7.05589C2.80454 7.30594 2.66406 7.64508 2.66406 7.9987V13.332C2.66406 13.6857 2.80454 14.0248 3.05459 14.2748C3.30464 14.5249 3.64377 14.6654 3.9974 14.6654H11.9974C12.351 14.6654 12.6902 14.5249 12.9402 14.2748C13.1903 14.0248 13.3307 13.6857 13.3307 13.332V7.9987C13.3307 7.64508 13.1903 7.30594 12.9402 7.05589C12.6902 6.80584 12.351 6.66536 11.9974 6.66536H11.3307V4.66536C11.3307 2.82736 9.8354 1.33203 7.9974 1.33203ZM5.9974 4.66536C5.9974 3.5627 6.89473 2.66536 7.9974 2.66536C9.10006 2.66536 9.9974 3.5627 9.9974 4.66536V6.66536H5.9974V4.66536ZM8.66406 11.814V13.332H7.33073V11.814C7.09765 11.6806 6.9105 11.4796 6.79395 11.2376C6.6774 10.9956 6.63692 10.724 6.67785 10.4585C6.71879 10.1931 6.83921 9.94628 7.02324 9.75065C7.20727 9.55502 7.44627 9.41976 7.70873 9.3627C7.90367 9.31959 8.10581 9.3208 8.30023 9.36622C8.49464 9.41164 8.67639 9.50013 8.83205 9.62515C8.98772 9.75016 9.11334 9.90853 9.19964 10.0886C9.28595 10.2686 9.33075 10.4657 9.33073 10.6654C9.33035 10.8985 9.26852 11.1275 9.15148 11.3291C9.03444 11.5308 8.86632 11.698 8.66406 11.814V11.814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecured);
export default __webpack_public_path__ + "static/media/secured.620aaad9b40f5c18e56c706c72e4c1b2.svg";
export { ForwardRef as ReactComponent };